import { Injectable } from '@angular/core';

/**
 * Coleções de Máscaras para utilizar em Inputs e labels
 */
@Injectable({
    providedIn: 'root'
})
export class MaskCollection {

    tel = '(00) 00000-0000';
    cnpj = '00.000.000/0000-00';
    cpf = '000.000.000-00';
    cpfToCnpj = '000.000.000-000';
    cnpjRecursoAssinatura = 'SS.SSS.SSS/';
    digito = 'SSSS-SS';
    constructor() { }

    /**
     * Método utilizado para campos híbridos que podem tanto ser CPF quanto CNPJ.
     * @param x CPF/CNPJ
     */
    isCpfOrCnpj(x: string): string {
        const clean = x?.replace(/[^a-zA-Z0-9]/g, '') || '';

        if (clean.length <= 11) {
            return this.cpfToCnpj;
        }

        return this.cnpj;
    }

    aplicaMascaraCpfCnpj(valor: string): string {
        if (!valor) {
            return '';
        }

        const alfanumerico = valor.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

        if (/^\d+$/.test(alfanumerico) && alfanumerico.length === 11) {
            return alfanumerico.replace(
                /(\d{3})(\d{3})(\d{3})(\d{2})/,
                '$1.$2.$3-$4'
            );
        }
        if (/^\d+$/.test(alfanumerico) && alfanumerico.length === 14) {
            return alfanumerico.replace(
                /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                '$1.$2.$3/$4-$5'
            );
        }
        if (alfanumerico.length <= 14) {
            return this.formatarCnpjAlfanumerico(alfanumerico);
        }

        return valor;
    }

    formatarCnpjAlfanumerico(valor: string): string {
        if (!valor) {
            return '';
        }

        const clean = valor
            .replace(/[^a-zA-Z0-9]/g, '')
            .toUpperCase()
            .substring(0, 14);

        let resultado = clean;

        if (clean.length > 2) {
            resultado = resultado.replace(/^(.{2})(.*)/, '$1.$2');
        }
        if (clean.length > 5) {
            resultado = resultado.replace(/^(.{6})(.*)/, '$1.$2');
        }
        if (clean.length > 8) {
            resultado = resultado.replace(/^(.{10})(.*)/, '$1/$2');
        }
        if (clean.length > 12) {
            resultado = resultado.replace(/^(.{15})(.*)/, '$1-$2');
        }
        return resultado;
    }

    formatarCpfCnpj(valor: any): string {

        if (valor === null || valor === undefined) {
            return '-';
        }

        const clean = String(valor)
            .replace(/[^a-zA-Z0-9]/g, '')
            .toUpperCase()
            .substring(0, 14);

        if (!clean) {
            return '-';
        }

        // CPF
        if (/^\d+$/.test(clean) && clean.length <= 11) {
            return clean.replace(
                /(\d{3})(\d{3})(\d{3})(\d{2})/,
                '$1.$2.$3-$4'
            );
        }

        // CNPJ numérico
        if (/^\d+$/.test(clean) && clean.length === 14) {
            return clean.replace(
                /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                '$1.$2.$3/$4-$5'
            );
        }

        // CNPJ alfanumérico
        return this.formatarCnpjAlfanumerico(clean);
    }

    formatarCpfCnpjRecursoAssinatura(valor: string): string {
        if (!valor) {
            return '';
        }

        const clean = valor.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

        // CPF (11 caracteres)
        if (clean.length === 11) {
            if (/^\d+$/.test(clean)) {
                return clean.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
            }
            return clean;
        }

        // CNPJ truncado (8 caracteres - primeiros dígitos/letras)
        if (clean.length === 8) {
            if (/^\d+$/.test(clean)) {
                return clean.replace(/(\d{2})(\d{3})(\d{3})/, '$1.$2.$3/');
            }
            return clean.replace(/^(.{2})(.{3})(.{3})/, '$1.$2.$3/');
        }

        // CNPJ completo (14 caracteres)
        if (clean.length >= 14) {
            if (/^\d+$/.test(clean)) {
                return clean.substring(0, 14).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
            }
            // Alfanumérico
            return this.formatarCnpjAlfanumerico(clean.substring(0, 14));
        }

        return valor;
    }
}

export const telPattern = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{5}))$/;
export const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}$/i;
